const injectSecondaryImages = () => {
	if (!window.matchMedia('(hover: hover)').matches) return;

	const templates = document.querySelectorAll('.secondary-image-template:not([data-injected])');

	templates.forEach((template) => {
		const container = template.closest('.media');
		if (!container) return;

		const primaryImage = container.querySelector('img:not(.secondary-image)');

		const inject = () => {
			const img = document.createElement('img');
			img.className = 'motion-reduce secondary-image';
			img.src = template.dataset.imageUrl;
			img.srcset = template.dataset.srcset;
			img.sizes = template.dataset.sizes;
			img.width = template.dataset.width;
			img.height = template.dataset.height;
			img.alt = '';
			container.appendChild(img);
			template.setAttribute('data-injected', 'true');
		};

		if (primaryImage && !primaryImage.complete) {
			primaryImage.addEventListener('load', inject, { once: true });
		} else {
			inject();
		}
	});
};

window.injectSecondaryImages = injectSecondaryImages;

document.addEventListener('DOMContentLoaded', () => {
	injectSecondaryImages();

	const observer = new MutationObserver(() => {
		injectSecondaryImages();
	});

	observer.observe(document.body, {
		childList: true,
		subtree: true
	});
});
